// extracted by mini-css-extract-plugin
export default {"self":"DevotionOfferingsLayout-module--self--PlYBA","footerWrapper":"DevotionOfferingsLayout-module--footerWrapper--f7nJQ"};